export enum EnrollmentReferenceEnum {
  enrollmentNumberCreche = 9,
  enrollmentNumberPreEscola = 10,
  enrollmentNumberEFAI = 12,
  enrollmentNumberEFAF = 13,
  enrollmentNumberEM = 13,
  enrollmentNumberEJA = 12
}
